module.exports = __webpack_public_path__ + "static/media/taraneh.d1a40b64.jpeg";